import script from "./BaseOauth.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseOauth.vue?vue&type=script&setup=true&lang=ts"

import "./BaseOauth.vue?vue&type=style&index=0&id=ff9a42be&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff9a42be"]])

export default __exports__